// import { WORDPRESS_API } from "shared/constants/api";

// export const qualificationsProject = {
//   id: "wklp",
//   title:
//     "Wyższe kwalifikacje, lepsze perspektywy – CKZiU w Wyrzysku kształci zawodowców",
//   projectNumber: "RPWP.08.03.01-30-0021/21",
//   period: "01.06.2022 – 30.06.2023",
//   value: "501 692,50 zł",
//   funding: "451 462,50 zł",
//   image: {
//     src: `${WORDPRESS_API}/wp-content/uploads/2022/08/Belka-EFS_Samorzad_kolor-PL-1-1024x104.jpg`,
//     alt: "Fundusze Europejskie",
//     maxWidth: "1024px"
//   }
// };

// export const qualificationsGoal =
//   "Głównym celem projektu jest nabycie kwalifikacji i kompetencji zawodowych oraz kluczowych, a także właściwych postaw i umiejętności uniwersalnych niezbędnych na rynku pracy przez 100 uczniów, wzrost kompetencji zawodowych 3 nauczycieli kształcenia zawodowego oraz poprawa warunków dydaktycznych poprzez doposażenie pracowni informatycznej.";

// export const qualificationsEffects = [
//   "Wyposażenie pracowni informatycznej dla zawodu technik informatyk w wysokiej jakości sprzęt.",
//   "Zdobycie doświadczenia zawodowego oraz wzmocnienie umiejętności praktycznych u 15 stażystów/stażystek.",
//   "Uzupełnienie i rozszerzenie wiedzy oraz kompetencji i kwalifikacji zawodowych u 100 uczniów/uczennic.",
//   "Zwiększenie umiejętności kluczowych w zakresie języka angielskiego u 18 uczniów/uczennic.",
//   "Wzrost kompetencji zawodowych 3 nauczycieli/nauczycielek kształcenia zawodowego."
// ];

// export const qualificationsSchedules = [
//   {
//     id: "kurs-kucharski-gr-1",
//     title: "NOWY TRENER Harmonogram kurs kucharski gr 1",
//     href: `${WORDPRESS_API}/wp-content/uploads/2019/03/NOWY-TRENER-Harmonogram-kurs-kucharski-gr-1.pdf`
//   },
//   {
//     id: "stylizacja-paznokci-gr-2",
//     title: "Harmonogram kurs stylizacji paznokci gr 2",
//     href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Harmonogram-kurs-stylizacji-paznokci-gr-2-1.pdf`
//   },
//   {
//     id: "makijaz-gr-2",
//     title: "Harmonogram kurs makijażu gr 2",
//     href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Harmonogram-kurs-makijazu-i-gr-2-1.pdf`
//   },
//   {
//     id: "harmonogramy-2023",
//     title: "Harmonogramy 2023",
//     href: `${WORDPRESS_API}/wp-content/uploads/2019/03/harmonogramy-2023-17.06.docx`
//   }
// ];

import { WORDPRESS_API } from "shared/constants/api";


export const qualificationsProject = {
  id: "wklp",

  title:
    "Wyższe kwalifikacje, lepsze perspektywy – CKZiU w Wyrzysku kształci zawodowców",

  description:
    "Projekt wspierający rozwój kompetencji zawodowych uczniów i nauczycieli oraz doposażenie pracowni zawodowych.",

  projectNumber: "RPWP.08.03.01-30-0021/21",

  period: "01.06.2022 – 30.06.2023",

  value: "501 692,50 zł",

  funding: "451 462,50 zł",

  programme: [
    "Oś priorytetowa 8 „Edukacja”",
    "Działanie 8.3. Wzmocnienie oraz dostosowanie kształcenia i szkolenia zawodowego do potrzeb rynku pracy",
    "Poddziałanie 8.3.1. Kształcenie zawodowe młodzieży – tryb konkursowy"
  ],

  image: {
    src: `${WORDPRESS_API}/wp-content/uploads/2022/08/Belka-EFS_Samorzad_kolor-PL-1-1024x104.jpg`,
    alt: "Fundusze Europejskie i Samorząd Województwa Wielkopolskiego",
    maxWidth: "1024px"
  }
};


export const qualificationsGoal =
  "Głównym celem projektu jest nabycie kwalifikacji i kompetencji zawodowych oraz kluczowych, a także właściwych postaw i umiejętności uniwersalnych niezbędnych na rynku pracy przez 100 uczniów, a także wzrost kompetencji zawodowych 3 nauczycieli kształcenia zawodowego oraz poprawa warunków dydaktycznych poprzez doposażenie pracowni informatycznej.";


export const qualificationsScope = [
  "Diagnoza potrzeb uczniów i nauczycieli, a następnie dobór odpowiednich form wsparcia.",
  "Udział uczniów w kursach, warsztatach i stażach zawodowych rozwijających kompetencje poszukiwane przez lokalnych pracodawców.",
  "Wsparcie nauczycieli w nabyciu kompetencji niezbędnych do nauczania zawodowego.",
  "Doposażenie pracowni zawodowych w celu zapewnienia warunków odzwierciedlających rzeczywiste warunki pracy."
];


export const qualificationsEffects = [
  "Wyposażenie pracowni informatycznej dla zawodu technik informatyk w CKZiU w Wyrzysku w wysokiej jakości sprzęt.",
  "Zdobycie doświadczenia zawodowego oraz wzmocnienie umiejętności praktycznych u 15 stażystów i stażystek.",
  "Uzupełnienie i rozszerzenie wiedzy oraz kompetencji i kwalifikacji zawodowych u 100 uczniów i uczennic.",
  "Zwiększenie umiejętności kluczowych w zakresie języka angielskiego u 18 uczniów i uczennic.",
  "Wzrost kompetencji zawodowych 3 nauczycieli i nauczycielek kształcenia zawodowego."
];

export const qualificationsSchedules = [
  {
    id: "kurs-kucharski-gr-1",
    title: "NOWY TRENER Harmonogram kurs kucharski gr 1",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/NOWY-TRENER-Harmonogram-kurs-kucharski-gr-1.pdf`
  },
  {
    id: "stylizacja-paznokci-gr-2",
    title: "Harmonogram kurs stylizacji paznokci gr 2",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Harmonogram-kurs-stylizacji-paznokci-gr-2-1.pdf`
  },
  {
    id: "makijaz-gr-2",
    title: "Harmonogram kurs makijażu gr 2",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Harmonogram-kurs-makijazu-i-gr-2-1.pdf`
  },
  {
    id: "harmonogramy-2023",
    title: "Harmonogramy 2023",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/harmonogramy-2023-17.06.docx`
  },
  {
    id: "makijaz-gr-1",
    title: "Kurs makijażu profesjonalnego",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Harmonogram-kurs-makijazu-i-gr-1.pdf`
  },
  {
    id: "prawo-jazdy",
    title: "Kurs prawa jazdy kat. B",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/HARMONOGRAM-prawo-katb.doc`
  },
  {
    id: "stylizacja-paznokci",
    title: "Kurs stylizacji paznokci",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Kurs-stylizacji-paznokci.pdf`
  },
  {
    id: "strony-www",
    title: "Kurs „Tworzenie i zarządzanie stronami WWW”",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Kurs-tworzenie-i-zarzadzanie-stronami-www.pdf`
  }
];

export const qualificationsTasks = [
  {
    id: "task-1",
    number: 1,
    title: "Doposażenie pracowni informatycznej",
    period: "01.06.2022 – 30.09.2022",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "W ramach zadania zaplanowano doposażenie pracowni informatycznej.",

    sections: [
      {
        title: "Zaplanowany sprzęt",
        items: [
          "25 zestawów komputerowych z oprogramowaniem",
          "Monitor interaktywny minimum 65 cali",
          "Stojak mobilny do monitora",
          "Program dietetyczny Pro Kcalmar"
        ]
      }
    ]
  },

  {
    id: "task-2",
    number: 2,
    title:
      "Warsztaty dla uczniów podnoszące kompetencje zawodowe",
    period: "01.06.2022 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "Warsztaty dla uczniów prowadzone przez nauczycieli zatrudnionych w szkole.",

    sections: [
      {
        title: "Język niemiecki techniczny",
        description:
          "Warsztaty dla uczniów technikum żywienia i usług gastronomicznych.",
        items: [
          "Podstawowe czynności w gastronomii",
          "Produkty spożywcze i dania",
          "Procesy technologiczne w gastronomii",
          "Akcesoria kuchenne i urządzenia gastronomiczne",
          "Przygotowanie dań",
          "Przepisy kulinarne"
        ]
      },
      {
        title: "Finger Food – wytrawne i słodkie zakąski",
        description:
          "Uczestnicy nabywali umiejętności przygotowywania nowoczesnych dań Finger Food."
      },
      {
        title: "Dietetyka Pro",
        description:
          "Zajęcia z wykorzystaniem programu do układania jadłospisów, prowadzenia wywiadu żywieniowego, wyliczania zapotrzebowania energetycznego i przygotowywania diet."
      },
      {
        title: "Obsługa konsumenta w gastronomii i cateringu",
        items: [
          "Metody i techniki obsługi gości",
          "Obsługa indywidualna gości z karty menu",
          "Przygotowanie sali na przyjęcie gości",
          "Wyposażenie do obsługi gości",
          "Użytkowanie sprzętu, zastawy i bielizny stołowej",
          "Przygotowanie personelu do obsługi gości",
          "Rodzaje posiłków",
          "Rodzaje przyjęć okolicznościowych"
        ]
      }
    ]
  },

  {
    id: "task-3",
    number: 3,
    title:
      "Zajęcia dodatkowe rozwijające kompetencje kluczowe i umiejętności uniwersalne",
    period: "01.06.2022 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "Zajęcia rozwijające umiejętności egzaminacyjne z języka angielskiego i przygotowujące do egzaminu maturalnego.",

    sections: [
      {
        title: "Program",
        items: [
          "Czytanie ze zrozumieniem",
          "Słuchanie ze zrozumieniem",
          "Tworzenie wypowiedzi pisemnych",
          "Mówienie i reagowanie językowe"
        ]
      }
    ]
  },

  {
    id: "task-4",
    number: 4,
    title: "Kurs prawa jazdy kategorii B",
    period: "01.06.2022 – 31.12.2022",
    location: "Wybrana szkoła nauki jazdy",

    description:
      "Kurs prawa jazdy kategorii B dla 15 uczniów i uczennic technikum oraz branżowej szkoły I stopnia."
  },

  {
    id: "task-5",
    number: 5,
    title: "Staże i praktyki zawodowe",
    period: "01.07.2022 – 31.08.2022",
    location:
      "Pracodawcy i przedsiębiorstwa z branży gastronomicznej i informatycznej",

    description:
      "Staże zawodowe dla 15 uczniów i uczennic w wymiarze 150 godzin, umożliwiające zdobycie praktycznego doświadczenia zawodowego."
  },

  {
    id: "task-6",
    number: 6,
    title: "Kurs kucharski I stopnia",
    period: "01.09.2022 – 31.12.2022",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "Wsparciem objęto uczniów kształcących się w zawodach kucharz, cukiernik oraz technik żywienia i usług gastronomicznych.",

    duration: "60 godzin dydaktycznych",

    sections: [
      {
        title: "Część teoretyczna",
        items: [
          "Rodzaje zakładów gastronomicznych i sposoby zarządzania",
          "Schemat odpowiedzialności pracy pracowników",
          "Kalkulacje i FOOD COST",
          "Podstawy prawne HACCP",
          "Zasady funkcjonowania systemu HACCP"
        ]
      },
      {
        title: "Warsztaty praktyczne",
        items: [
          "Procesy technologiczne i urządzenia stosowane w produkcji żywności",
          "Technika krojenia",
          "Technika dekorowania i serwowania potraw",
          "Sporządzanie wywarów, sosów, marynat, potraw śniadaniowych, zup i dań mącznych"
        ]
      }
    ]
  },

  {
    id: "task-7",
    number: 7,
    title: "Kurs „Tworzenie i zarządzanie stronami WWW”",
    period: "01.09.2022 – 31.12.2022",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "Kurs dla uczniów kształcących się w zawodzie technik informatyk.",

    duration: "35 godzin dydaktycznych",

    sections: [
      {
        title: "HTML",
        items: [
          "Umieszczanie i formatowanie tekstu",
          "Stosowanie tabel",
          "Opracowywanie formularzy",
          "Budowa stron internetowych"
        ]
      },
      {
        title: "CSS",
        items: [
          "Budowa i struktura stylu",
          "Umieszczanie stylów w dokumencie",
          "Formatowanie tekstu",
          "Kolory, tła, odstępy i marginesy",
          "Obramowania i pozycjonowanie",
          "Selektory, klasy i identyfikatory"
        ]
      },
      {
        title: "JavaScript",
        items: [
          "Wprowadzenie do JavaScript",
          "Typy referencyjne",
          "Programowanie obiektowe",
          "Funkcje anonimowe",
          "Browser Object Model",
          "Document Object Model",
          "Zdarzenia",
          "Obsługa formularzy",
          "Obsługa wyjątków i debugowanie"
        ]
      },
      {
        title: "PHP",
        items: [
          "Składnia języka PHP",
          "Struktury danych",
          "Programowanie obiektowe w PHP"
        ]
      }
    ]
  },

  {
    id: "task-8",
    number: 8,
    title: "Kurs stylizacji paznokci",
    period: "01.09.2022 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "Kurs dla uczniów technikum i branżowej szkoły I stopnia.",

    duration: "45 godzin dydaktycznych na grupę",

    sections: [
      {
        title: "Program kursu",
        items: [
          "Anatomia paznokci",
          "Manicure biologiczny",
          "Manicure cążkowy",
          "Manicure frezarkowy",
          "Manicure SPA",
          "Manicure japoński",
          "Żel na naturalną płytkę",
          "Manicure hybrydowy",
          "Metoda żelowa na tipsie",
          "Metoda żelowa na formie"
        ]
      }
    ]
  },

  {
    id: "task-9",
    number: 9,
    title: "Kurs makijażu profesjonalnego",
    period: "01.09.2022 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    duration: "24 godziny dydaktyczne na grupę",

    description:
      "Kurs obejmował podstawy profesjonalnego makijażu, analizę typu cery i urody, dobór kosmetyków oraz różne techniki makijażu."
  },

  {
    id: "task-10",
    number: 10,
    title:
      "Doskonalenie kompetencji zawodowych nauczycieli – kurs kucharski I stopnia",
    period: "01.09.2022 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "Wsparciem objęto 3 nauczycieli i nauczycielki kształcenia zawodowego.",

    duration: "60 godzin dydaktycznych",

    sections: [
      {
        title: "Zakres kursu",
        items: [
          "Rodzaje zakładów gastronomicznych i sposoby zarządzania",
          "Kalkulacje i FOOD COST",
          "System HACCP",
          "Procesy technologiczne w gastronomii",
          "Technika krojenia",
          "Dekorowanie i serwowanie potraw",
          "Sporządzanie wywarów, sosów, marynat, zup i dań mącznych"
        ]
      }
    ]
  },

  {
    id: "task-11-confectionery",
    number: 11,
    title: "Kurs cukierniczy",
    period: "02.01.2023 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    duration: "40 godzin dydaktycznych",

    description:
      "Kurs dla uczniów kształcących się w zawodach kucharz, cukiernik oraz technik żywienia i usług gastronomicznych.",

    sections: [
      {
        title: "Program kursu",
        items: [
          "Niezbędnik cukiernika",
          "Kruche i półkruche ciasta",
          "Ciasta ucierane",
          "Ciasta biszkoptowe",
          "Rolady i krajanki tortowe",
          "Kremy, pianki, musy, mleczka oraz panna cotta"
        ]
      }
    ]
  },

  {
    id: "task-12-sommelier",
    number: 12,
    title: "Kurs sommelierski",
    period: "02.01.2023 – 30.06.2023",
    location:
      "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    duration: "16 godzin dydaktycznych",

    description:
      "Kurs dla uczniów kształcących się w zawodzie kucharz oraz technik żywienia i usług gastronomicznych.",

    sections: [
      {
        title: "Program kursu",
        items: [
          "Zawód sommeliera",
          "Kraje winiarskie i produkcja wina",
          "Typologia i klasyfikacja jakościowa",
          "Charakterystyka szczepów",
          "Wina słodkie i musujące",
          "Odczytywanie etykiet",
          "Profesjonalna degustacja",
          "Serwowanie i przechowywanie wina",
          "Dobór wina do potraw",
          "Psychologia sprzedaży"
        ]
      }
    ]
  }
];

export const qualificationsDocuments = [
  {
    id: "harmonogram-realizacji",
    title: "Harmonogram realizacji zadań w projekcie",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Harmonogram-realizacji-zadan-w-projekcie-CKZiU-w-Wyrzysku.docx`
  },
  {
    id: "regulamin-projektu",
    title: "Regulamin projektu",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/REGULAMIN-PROJEKTU.pdf`
  },
  {
    id: "oswiadczenie-uczestnika",
    title: "Oświadczenie uczestnika",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Oswidczenie-uczestnika-projektu_CKZiU.pdf`
  },
  {
    id: "oswiadczenie-miejsce-nauki",
    title: "Oświadczenie o miejscu pobierania nauki",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Oswiadczenie-o-miejscu-pobierania-nauki_CKZiU.pdf`
  },
  {
    id: "formularz-rekrutacyjny",
    title: "Wzór formularza rekrutacyjnego",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Wzor_formularza_rekrutacyjnego_CKZiU.pdf`
  },
  {
    id: "plakat-jpg",
    title: "Plakat poziomy CKZiU (JPG)",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Plakat-poziomy-CKZiU.jpg`
  },
  {
    id: "plakat-pdf",
    title: "Plakat poziomy CKZiU (PDF)",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Plakat-poziomy-Powiat_CKZiU.pdf`
  }
];